import React from 'react'
import { Container } from 'theme-ui'

const Sticky = ({ children }) => (
  <Container variant='sticky'>{children}</Container>
)

export default Sticky
